/**
 * Every user-facing product and model name lives here. The model family name ("Hartley", first model Hartley 1) is the name for now: change it
 * in this file (and the model rows in the database, see docs/NAMING.md) and nothing else needs touching.
 */
export const BRAND = {
  company: 'Trodo',
  /** The app: sign-in, playground, keys, usage, billing, members, admin. */
  consoleName: 'Trodo Console',
  /** The first model family served through the console; its first model is Hartley 1. */
  modelFamily: 'Hartley',
  /** Prefix of public model ids, e.g. `hartley-1`. */
  modelIdPrefix: 'hartley',
  /** Id callers get when they omit `model`. */
  defaultModelId: 'hartley-1',
  tagline: 'Typed, calibrated decisions in one forward pass',
  supportEmail: 'support@trodo.ai',
} as const

export type Brand = typeof BRAND
